@for (resourceAttendee of event().resourceAttendees; track $index) {
  @if (resourceAttendee.statusesByDay.length > 2 && event().start.utcDateTime < now) {
    <kendo-expansionpanel
      class="show-panel hide-border"
      expandIcon="k-icon k-font-icon k-i-plus"
      collapseIcon="fa fa-minus"
      [title]="getExpandeTitle(resourceAttendee, resourceAttendee.resource | resourceTitle)"
    >
      @for (text of getExpanderTexts(resourceAttendee, resourceAttendee.resource | resourceTitle); track $index) {
        <div>{{ text }}</div>
      }
    </kendo-expansionpanel>
  } @else {
    @if (resourceAttendee.status === 'confirmed') {
      <div class="confirmed">
        <div
          class="icon-wrapper"
          [cueTooltip]="
            translation.reservations.confirmed
              | transloco
                : {
                    when: (resourceAttendee.confirmedWhen! | dateTimeFormat),
                    who: resourceAttendee.confirmedBy,
                    resourceName: resourceAttendee.resource | resourceTitle,
                  }
          "
          [cueTooltipPosition]="position"
          cueTooltipCommonType="info"
        >
          <cue-icon [icon]="ICONS.cueExclamationCircle" />
        </div>

        <span>
          {{
            translation.reservations.confirmed
              | transloco
                : {
                    when: (resourceAttendee.confirmedWhen! | dateTimeFormat),
                    who: resourceAttendee.confirmedBy,
                    resourceName: resourceAttendee.resource | resourceTitle,
                  }
          }}</span
        >
      </div>
    } @else {
      @if (resourceAttendee.confirmAvailable) {
        <div class="confirmation-required-alert" (click)="confirmOnLabels() ? onLabelConfirm($event) : 0">
          <div class="icon-wrapper">
            <cue-icon [icon]="ICONS.cueExclamationCircle" />
          </div>

          <span>
            {{
              translation.reservations.confirmationRequiredUntil
                | transloco
                  : {
                      until: resourceAttendee.confirmationMetadata.higherBorderTime | dateTimeFormat,
                      resourceName: (resourceAttendee.resource | resourceTitle),
                    }
            }}</span
          >
        </div>
      } @else if (resourceAttendee.status === 'need-confirmation') {
        <div class="need-confirmation">
          <div class="icon-wrapper">
            <cue-icon [icon]="ICONS.cueExclamationCircle" />
          </div>

          <span>
            {{
              getTextKeyForConfirmation(resourceAttendee)
                | transloco
                  : {
                      from: resourceAttendee.confirmationMetadata.lowerBorderTime | dateTimeFormat,
                      to: resourceAttendee.confirmationMetadata.higherBorderTime | dateTimeFormat,
                      resourceName: (resourceAttendee.resource | resourceTitle),
                    }
            }}</span
          >
        </div>
      }
    }
  }
}

@if (confirmAvailable() && showBigConfirmButton()) {
  <button cue-button size="default" class="xs-font-small w-full mt-1.5" (click)="onConfirm($event)">
    <cue-icon [icon]="ICONS.cueCheckCircle" style="--icon-color: white" />
    <span>{{ translation.dashboard.confirm | transloco }}</span>
  </button>
}

<div class="wrapper">
  <div class="wrapper-content" (click)="onDetail($event)">
    @if (showImage() || showNavigate()) {
      <div class="image-wrapper">
        @if (showImage()) {
          @if (event().resourceAttendees.length > 0 && event().resourceAttendees[0].files.length > 0) {
            @switch (event().resourceAttendees[0].files[0].type) {
              @case (AssistResourceFileType.Matterport) {
                <img
                  loading="lazy"
                  [ngStyle]="{
                    'object-position': event().resourceAttendees[0].files[0].imageObjectPosition,
                  }"
                  [class.!object-cover]="event().resourceAttendees[0].files[0].imagePreferCover"
                  [src]="event().resourceAttendees[0].files[0].file | imageWidth: 350"
                  (error)="onImageError($event)"
                />
              }
              @case (AssistResourceFileType.Image) {
                <img
                  loading="lazy"
                  [ngStyle]="{
                    'object-position': event().resourceAttendees[0].files[0].imageObjectPosition,
                  }"
                  [class.!object-cover]="event().resourceAttendees[0].files[0].imagePreferCover"
                  [src]="event().resourceAttendees[0].files[0].file | imageWidth: 350"
                  (error)="onImageError($event)"
                />
              }
              @case (AssistResourceFileType.Video) {
                <video [src]="event().resourceAttendees[0].files[0].file" preload="metadata"></video>
              }
              @default {
                <img
                  loading="lazy"
                  [ngStyle]="{
                    'object-position': event().resourceAttendees[0].files[0].imageObjectPosition,
                  }"
                  [class.!object-cover]="event().resourceAttendees[0].files[0].imagePreferCover"
                  [src]="'/assets/images/placeholder.jpg'"
                />
              }
            }
          } @else {
            <img loading="lazy" [src]="'/assets/images/placeholder.jpg'" />
          }
        }

        @if (showNavigate()) {
          @if (configService.value.navigationEnabled && navigateableResourceAttendees().length > 0 && !isColleague()) {
            @if (navigateableResourceAttendees().length === 1) {
              <div class="navigate-button" (click)="onNavigate($event, navigateableResourceAttendees()[0])">
                <p>
                  <cue-icon [icon]="ICONS.cueDirections" />
                  {{ translation.reservations.navigateTo | transloco }}
                </p>
              </div>
            } @else {
              <div class="navigate-button">
                <kendo-dropdownbutton
                  (click)="$event.stopPropagation()"
                  (itemClick)="onItemNavigate($event)"
                  [data]="navigateableResourceAttendees()"
                  [arrowIcon]="true"
                  themeColor="none"
                  [popupSettings]="{ popupClass: 'assist-select-style' }"
                >
                  <ng-template kendoDropDownButtonItemTemplate let-dataItem>
                    <span>{{ dataItem.resource | resourceTitle }}</span>
                  </ng-template>
                  <cue-icon [icon]="ICONS.cueDirections" />
                  {{ translation.reservations.navigateTo | transloco }}
                </kendo-dropdownbutton>
              </div>
            }
          }
        }
      </div>
    }
    <div
      class="content-wrapper"
      [class.ml-0]="!showImage() && !showNavigate()"
      [class.w-100]="!showImage() && !showNavigate()"
      [class.has-repetition-badge]="isRepetitiveEvent()"
    >
      @if (isRepetitiveEvent()) {
        <div class="repetition-type-badge repetition-type-badge-corner">
          {{ repetitiveEventTypeLabel() }}
        </div>
      }
      <div class="header">
        <div class="duration-wrapper desktop">
          @if (!isAllDayEvent()) {
            <div class="time-date start">
              <p class="date">
                {{ event().start.utcDateTime | dateFormat }}
              </p>
              <p class="time">
                {{ event().start.utcDateTime | timeFormat }}
              </p>
              <p class="type">
                {{ translation.common.starts | transloco }}
              </p>
            </div>
            <div class="line"></div>
            <div class="time-date end">
              <p class="date">
                {{ event().end.utcDateTime | dateFormat }}
              </p>
              <p class="time">
                {{ event().end.utcDateTime | timeFormat }}
              </p>
              <p class="type">
                {{ translation.common.ends | transloco }}
              </p>
            </div>
          } @else {
            <div class="time-date start">
              <p class="date">
                {{ event().start.utcDateTime | dateFormat }}
              </p>
              <p class="time">
                {{ translation.reservationPopup.allDay | transloco }}
              </p>
            </div>
          }
        </div>
        <div class="inner-content-wrapper">
          <div class="text break-words">
            <h3 title="{{ event().subject | subjectPipe }}">
              {{ event().subject | subjectPipe }}
            </h3>

            @if (event().finished) {
              <div class="state mobile finished">
                {{ translation.common.finished | transloco }}
              </div>
            }

            @if (event().cancelled) {
              <div class="state mobile rejected">
                {{ translation.common.cancelled | transloco }}
              </div>
            }
            <div class="place flex flex-col gap-1" [class.inactive]="!showNavigate()">
              @for (resourceAttendee of event().resourceAttendees; track $index) {
                <div class="flex flex-row gap-3 items-center justify-between resource-and-state">
                  <div class="break-words">
                    <cue-icon
                      [icon]="ICONS.cueCompass"
                      (click)="confirmOnLabels() ? onLabelConfirm($event) : onShow($event, resourceAttendee)"
                    />
                    <span (click)="confirmOnLabels() ? onLabelConfirm($event) : onShow($event, resourceAttendee)">{{
                      (resourceAttendee.resource.displayNameForApp | localizedString) ??
                        (resourceAttendee.resource.displayName | localizedString)
                    }}</span>
                  </div>
                  @if (!event().cancelled) {
                    <div class="state" [ngClass]="getTextKeyAndClass(resourceAttendee)[1]">
                      {{ getTextKeyAndClass(resourceAttendee)[0] | transloco }}
                    </div>
                  }
                </div>
              }
            </div>
            <p
              class="user"
              [cueTooltip]="emailTemplate"
              cueTooltipCommonType="info"
              #user
              (click)="copyToClipboard(event().organizer?.emailAddress?.address, $event, user)"
            >
              <cue-icon [icon]="ICONS.cueUser" />
              <span>{{ event().organizer?.emailAddress?.name ?? event().organizer?.emailAddress?.address }} </span>
            </p>
            @let attendeesWithoutResourceAttendeesCount = event().attendees.length - event().resourceAttendees.length;
            @let removeUserCount = currentUserInAttendees() ? 1 : 0;
            @let totalAddCount = attendeesWithoutResourceAttendeesCount - removeUserCount;
            @if (totalAddCount > 0) {
              <p class="attendees">
                <span>
                  {{ totalAddCount }}
                  {{ translation.reservationPopup.attendees | transloco }}
                </span>
              </p>
            }
            <ng-template #emailTemplate>
              <div class="mail">
                <a>
                  {{ event().organizer?.emailAddress?.address }}
                </a>
              </div>
            </ng-template>

            @if (totalOrdersItemCount() > 0) {
              <p class="order-items">
                <cue-icon [icon]="ICONS.cueOrders" />
                <span>{{
                  translation.orders.countOrderedServices | transloco: { count: totalOrdersItemCount() }
                }}</span>
              </p>
            }
          </div>
          <div class="duration-wrapper mobile">
            <div class="divider"></div>
            @if (!isAllDayEvent()) {
              <div class="time-date start">
                <p class="date">
                  {{ event().start.utcDateTime | dateFormat }}
                </p>
                <p class="time">
                  {{ event().start.utcDateTime | timeFormat }}
                </p>
                <p class="type">
                  {{ translation.common.starts | transloco }}
                </p>
              </div>
              <div class="line"></div>
              <div class="time-date end">
                <p class="date">
                  {{ event().end.utcDateTime | dateFormat }}
                </p>
                <p class="time">
                  {{ event().end.utcDateTime | timeFormat }}
                </p>
                <p class="type">
                  {{ translation.common.ends | transloco }}
                </p>
              </div>
            } @else {
              <div class="time-date start">
                <p class="date">
                  {{ event().start.utcDateTime | dateFormat }}
                </p>
                <p class="time">
                  {{ translation.reservationPopup.allDay | transloco }}
                </p>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="buttons">
        @if (event().finished) {
          <div class="state mobile finished">
            {{ translation.common.finished | transloco }}
          </div>
        }
        @if (event().cancelled) {
          <div class="state mobile rejected">
            {{ translation.common.cancelled | transloco }}
          </div>
        }

        @if (
          showNavigate() &&
          navigateableResourceAttendees().length > 0 &&
          configService.value.navigationEnabled &&
          !isColleague()
        ) {
          @if (navigateableResourceAttendees().length === 1) {
            <div class="reservation-button navigate" (click)="onNavigate($event, navigateableResourceAttendees()[0])">
              <cue-icon [icon]="ICONS.cueDirections" />
              <span>{{ translation.reservations.navigateTo | transloco }}</span>
            </div>
          } @else {
            <div class="reservation-button navigate">
              <kendo-dropdownbutton
                (click)="$event.stopPropagation()"
                (itemClick)="onItemNavigate($event)"
                [data]="navigateableResourceAttendees()"
                [arrowIcon]="false"
                themeColor="none"
              >
                <ng-template kendoDropDownButtonItemTemplate let-dataItem>
                  <span>{{ dataItem.resource | resourceTitle }}</span>
                </ng-template>
                <cue-icon [icon]="ICONS.cueDirections" />
              </kendo-dropdownbutton>
            </div>
          }
        }
        @if (!isColleague() && event().showDeleteButton) {
          @if (isOccurrenceLikeEvent()) {
            <div data-cy="assist-reservation-card-delete" class="reservation-button cancel" (click)="onDelete($event)">
              <cue-icon [icon]="ICONS.cueClose" />
              <span>{{ translation.reservationPopup.deleteOccurrence | transloco }}</span>
            </div>
            <div class="reservation-button cancel series-delete-button" (click)="onDeleteSeries($event)">
              <cue-icon [icon]="ICONS.cueClose" />
              <span class="series-scope-prefix">{{ translation.reservationPopup.seriesScopeLabel | transloco }}</span>
              <span class="series-delete-label">{{ translation.reservationPopup.deleteSeries | transloco }}</span>
            </div>
          } @else if (isSeriesMasterEvent()) {
            <div class="reservation-button cancel series-delete-button" (click)="onDeleteSeries($event)">
              <cue-icon [icon]="ICONS.cueClose" />
              <span class="series-scope-prefix">{{ translation.reservationPopup.seriesScopeLabel | transloco }}</span>
              <span class="series-delete-label">{{ translation.reservationPopup.deleteSeries | transloco }}</span>
            </div>
          } @else {
            <div data-cy="assist-reservation-card-delete" class="reservation-button cancel" (click)="onDelete($event)">
              <cue-icon [icon]="ICONS.cueClose" />
              <span>{{ translation.dashboard.deleteEvent | transloco }}</span>
            </div>
          }
        }

        @if (
          !event().finished &&
          !isColleague() &&
          !event().isOrganizer &&
          !event().cancelled &&
          !isColleague() &&
          event().meAttending
        ) {
          <div class="reservation-button cancel" (click)="onCancelParticipation($event)">
            <cue-icon [icon]="ICONS.cueClose" />
            <span>{{ translation.dashboard.cancelParticipation | transloco }}</span>
          </div>
        }
        @if (event().showChangeButton && !isColleague()) {
          <div data-cy="assist-reservation-card-edit" class="reservation-button change" (click)="onChange($event)">
            <cue-icon [icon]="ICONS.cueShuffle" />
            <span>{{ translation.reservationPopup.change | transloco }}</span>
          </div>
        }
        @if (!isColleague() && event().showFinishButton) {
          <div class="reservation-button finish" (click)="onFinish($event)">
            <cue-icon [icon]="ICONS.cueFinish" />
            <span>{{ translation.finishEvent.finish | transloco }}</span>
          </div>
        }
        @if (confirmAvailable()) {
          <div class="reservation-button confirm" (click)="onConfirm($event)">
            <cue-icon [icon]="ICONS.cueCheckCircle" />
            <span>{{ translation.dashboard.confirm | transloco }}</span>
          </div>
        }

        @if (!isColleague() || (event().canViewFromColleague && !event().canEditFromColleague)) {
          <div data-cy="assist-reservation-card-detail" class="reservation-button detail" (click)="onDetail($event)">
            <cue-icon [icon]="ICONS.cueSearch" />
            <span>{{ translation.dashboard.eventDetail | transloco }}</span>
          </div>
        }
      </div>
    </div>
    @if (!isColleague()) {
      <cue-icon class="search-icon" [icon]="ICONS.cueSearch" />
    }
  </div>
</div>
